module.exports = __webpack_public_path__ + "img/623.669463a9.jpg";